import { memo } from "react"

const HeikinAshi = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M7.71429 6.85714V17.1429H10.2857V6.85714H7.71429ZM6.85714 6.42686C6.85714 6.19114 7.04143 6 7.284 6H10.716C10.9517 6 11.1429 6.18857 11.1429 6.42686V17.5731C11.1434 17.6294 11.1328 17.6851 11.1115 17.7372C11.0903 17.7892 11.0589 17.8365 11.0191 17.8763C10.9794 17.916 10.9321 17.9474 10.88 17.9687C10.828 17.9899 10.7722 18.0006 10.716 18H7.284C7.22788 18.0002 7.17227 17.9893 7.12038 17.968C7.06849 17.9466 7.02134 17.9152 6.98166 17.8755C6.94198 17.8358 6.91054 17.7887 6.88917 17.7368C6.8678 17.6849 6.85692 17.6293 6.85714 17.5731V6.42686Z"
                fill="currentColor"/>
            <path d="M8.57143 3.42859H9.42857V6.42859H8.57143V3.42859Z" fill="currentColor"/>
            <path
                d="M14.5714 5.14285V10.2857H17.1429V5.14285H14.5714ZM13.7143 4.71428C13.7143 4.47771 13.8986 4.28571 14.1411 4.28571H17.5731C17.8089 4.28571 18 4.48285 18 4.71428V10.7143C18 10.9508 17.8157 11.1428 17.5731 11.1428H14.1411C14.028 11.1417 13.9198 11.0962 13.8399 11.016C13.7601 10.9358 13.715 10.8274 13.7143 10.7143V4.71428Z"
                fill="currentColor"/>
            <path d="M15.4286 1.71429H16.2857V4.71429H15.4286V1.71429Z" fill="currentColor"/>
        </svg>
    )
}

export default memo(HeikinAshi)